import React, { useState } from "react";
import "../assets/css/icomoon.css";
import creteImage from "../assets/images/crete-logo-new.png";
function Footer() {
    const [loading, setLoading] = useState(true);
  return (
    <>
      {/* ================= FOOTER ================= */}
	  <div className="clearfix"></div>
      <footer className="ftco-footer ftco-bg-dark ftco-section">
        <div className="container">

          <div className="row">

            {/* ================= COMPANY INFO ================= */}
            <div className="col-md">
              <div className="ftco-footer-widget mb-4">

                <h2 className="ftco-heading-2">
                  <a href="/" className="logof">
                    <img
                      src={creteImage}
                      alt="Crete Holidays Logo"
                    />
                  </a>
                </h2>

                <div className="block-23 mb-3">

                  <ul>

                    <li>
                      <span className="icon icon-map-marker"></span>

                      <span className="text">
                        El. Venizelou 20, Hersonissos
                        <br />
                        70014, Crete
                        <br />
                        Greece
                      </span>
                    </li>

                  </ul>

                </div>

                {/* ================= SOCIAL MEDIA ================= */}
                <ul
                  className="ftco-footer-social list-unstyled float-md-left float-lft"
                  style={{
                    paddingLeft: "36px",
                  }}
                >

                  <li>
                    <a href="#">
                      <span className="icon-google-plus"></span>
                      
                    </a>
                  </li>

                  <li>
                    <a href="#">
                      <span className="icon-facebook"></span>
                    </a>
                  </li>

                  <li>
                    <a href="#">
                      <span className="icon-instagram"></span>
                    </a>
                  </li>

                </ul>

              </div>
            </div>

            {/* ================= INFORMATION ================= */}
            <div className="col-md">

              <div className="ftco-footer-widget">

                <h2 className="ftco-heading-2">
                  Information
                </h2>

                <ul className="list-unstyled">

                 {/* <li>
                    <a href="/" className="d-block">
                      Home
                    </a>
                  </li>

                  <li>
                    <a href="/about" className="d-block">
                      About us
                    </a>
                  </li>

                  <li>
                    <a href="/cars" className="d-block">
                      Our cars
                    </a>
                  </li>*/}

                  <li>
                    <a href="/booking" className="d-block">
                      Book a car
                    </a>
                  </li>
 <li>
                    <a href="/terms-and-conditions" className="d-block">
                      Terms and Condition
                    </a>
                  </li>
                  <li>
                    <a href="/policy" className="d-block">
                     Policy
                    </a>
                  </li>
                     <li>
                    <a href="/sitemap" className="d-block">
                     Sitemap
                    </a>
                  </li>
                  <li>
                    <a
                      href="/modify-reservation"
                      className="d-block"
                    >
                      Modify reservation
                    </a>
                  </li>

                  <li>
                    <a href="/faq" className="d-block">
                      FAQ
                    </a>
                  </li>

                </ul>

              </div>

            </div>

            {/* ================= LOCATION ================= */}
            <div className="col-md">

              <div className="ftco-footer-widget">

                <h2 className="ftco-heading-2">
                  Location
                </h2>

                <ul className="list-unstyled">

                  <li>
                    <a href="#" className="d-block">
                      Crete Main Station
                    </a>
                  </li>

                  <li>
                    <a href="#" className="d-block">
                      Car Rental Heraklion Airport
                    </a>
                  </li>

                  <li>
                    <a href="#" className="d-block">
                      Car Rental Chania Airport
                    </a>
                  </li>

                  <li>
                    <a href="#" className="d-block">
                      Car rental Heraklion Port
                    </a>
                  </li>

                  <li>
                    <a href="#" className="d-block">
                      Car rental Hersonissos Crete
                    </a>
                  </li>

                  <li>
                    <a href="#" className="d-block">
                      Car rental Gouves Crete
                    </a>
                  </li>

                </ul>

              </div>

            </div>

            {/* ================= CONTACT ================= */}
            <div className="col-md">

              <div className="ftco-footer-widget">

                <h2 className="ftco-heading-2">
                  Have a Questions?
                </h2>

                <div className="block-23 mb-3">

                  <ul>

                    {/* WhatsApp */}
                    <li>

                      <span className="icon icon-whatsapp"></span>

                      <span className="text">
                        +31- 97010204725
                        <br />
                        (during office hours)
                      </span>

                    </li>

                    {/* Email */}
                    <li>

                      <a href="mailto:info@crete-holidays.net">

                        <span className="icon icon-envelope"></span>

                        <span className="text">
                          info@crete-holidays.net
                        </span>

                      </a>

                    </li>

                  </ul>

                </div>

              </div>

            </div>

          </div>

        </div>
      </footer>

      {/* ================= COPYRIGHT ================= */}
      <div
        style={{
          backgroundColor: "#0e1b44",
          padding: "10px 0",
        }}
      >
        <div className="container">

          <div className="row">

            <div className="col-md-12 text-center">

              <p
                style={{
                  color: "#fff",
                  margin: 0,
                }}
              >
                Copyright &copy; All Rights Reserved By
                Crete Holidays
                <br />
                Powered By Orisys Infotech Pvt. Ltd.
              </p>

            </div>

          </div>

        </div>
      </div>

      {/* ================= LOADER ================= 
      {loading && (
        <div
          id="ftco-loader"
          className="show fullscreen"
          onClick={() => setLoading(false)}
        >
          <svg
            className="circular"
            width="48px"
            height="48px"
            viewBox="0 0 48 48"
          >
            <circle
              className="path-bg"
              cx="24"
              cy="24"
              r="22"
              fill="none"
              strokeWidth="4"
              stroke="#eeeeee"
            />

            <circle
              className="path"
              cx="24"
              cy="24"
              r="22"
              fill="none"
              strokeWidth="4"
              strokeMiterlimit="10"
              stroke="#F96D00"
            />
          </svg>
        </div>
      )}*/}
    </>
  );
}

export default Footer;